<template>
  <div id="app">
    <menus
      ref="menus"
      @onSelect="onSelectMenus"
    />
    <router-view/>
    <footerBox
      ref="footBox"
      :hiddenContact="hiddenContact"
      @onSelect="onSelectFooterBox"
    />
  </div>
</template>
<script>
import menus from './components/menus'
import footerBox from './components/footerBox'
export default {
  components: {
    menus,
    footerBox
  },
  data () {
    return {
      hiddenContact: false // 隐藏底部的联系我们
    }
  },
  methods: {
    onSelectMenus (path) {
      this.$refs.footBox.curSelect = path

      this.hiddenContact = path === '/contact'
    },
    onSelectFooterBox (path) {
      this.$refs.menus.curSelect = path
      this.hiddenContact = path === '/contact'
      window.scrollTo({
        top: 0,
        left: 0
      })
    }
  }
}
</script>
<style>
  *{
    margin: 0px;
    padding: 0px;
    /* font-family: "微软雅黑" !important; */
    font-family: "-apple-system", BlinkMacSystemFont, "Yu Gothic Medium", "游ゴシック Medium", YuGothic, "游ゴシック体", "Noto Sans Japanese", "ヒラギノ角ゴ Pro W3", "メイリオ", "Hiragino Kaku Gothic ProN", "MS PGothic", Osaka, "sans-serif" !important;
  }
  .swiper-pagination-bullet{
    background-color: white !important;
    width: 10px;
    height: 10px;
  }
  .swiper-pagination-bullet-active{
    background: #E09B4D !important;
  }

  .swiper-pagination{
    text-align: left !important;
    bottom: 73px !important;
    left: 76px !important;
  }
  .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
    margin: 0px 8px !important;
  }
  .el-select .el-input__inner{
    height: 56px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #CCCCCC;
    font-size: 20px;
    padding: 0px 10px;
  }
  .el-select .el-input.is-focus .el-input__inner,
  .el-select .el-input__inner:focus{
    border: 2px solid #0660cc !important;
  }
  .el-select-dropdown__item.selected{
    color: #0660cc !important;
  }
  .el-icon-arrow-up:before {
    content: "\E605";
  }
</style>
<style lang="less" scoped>
  #app{
    width: 1905px;
    margin: 0 auto;
    overflow-x: hidden;
    position: relative;
  }
</style>
